<gp-drawer [open]="open" (openChange)="onDrawerOpenChange($event)" width="460px">

  <!-- Header: avatar + name + email -->
  <div drawer-header class="profile-header" *ngIf="user">
    <div class="profile-avatar" (click)="employee && avatarUploader.click()">
      <gp-user-avatar [pictureUri]="employee?.photoLink?.href"
                      [initials]="initials()"
                      size="md"
                      classes="{{employee ? 'pointer hover-plus' : ''}}">
      </gp-user-avatar>
      <input #avatarUploader type="file" accept="image/*" (change)="photoSelected($event)" class="hide"/>
    </div>
    <div class="profile-identity">
      <div class="profile-name">{{ user.firstName }} <strong>{{ user.lastName }}</strong></div>
      <div class="profile-email">{{ user.email }}</div>
    </div>
  </div>

  <!-- Body: account preferences -->
  <ng-container *ngIf="user" [formGroup]="form">
    <p class="profile-hint">{{ 'ME.preferences_hint' | translate }}</p>

    <div class="profile-field" test-id="profile-drawer-language">
      <label>{{ 'ME.your_language' | translate }}</label>
      <gp-dropdown-select formControlName="language"
                          buttonClasses="w-100"
                          menuClasses="dropdown-menu-min">
        <gp-dropdown-option *ngFor="let language of languages | keys" [ngValue]="language">
          {{ languages[language] }}
        </gp-dropdown-option>
      </gp-dropdown-select>
    </div>

    <div class="profile-field" test-id="profile-drawer-timezone">
      <label>{{ 'ME.your_timezone' | translate }}</label>
      <gp-dropdown-select formControlName="timezone"
                          buttonClasses="w-100"
                          menuClasses="dropdown-menu-min">
        <gp-dropdown-option *ngFor="let zone of timezoneNames" [ngValue]="zone.value">
          {{ zone.name }}
        </gp-dropdown-option>
      </gp-dropdown-select>
    </div>

    <div class="profile-field" test-id="profile-drawer-number-format">
      <label>{{ 'ME.your_numberFormat' | translate }}</label>
      <gp-dropdown-select formControlName="numberFormat"
                          buttonClasses="w-100"
                          menuClasses="dropdown-menu-min">
        <ng-container *ngFor="let decimalSymbol of numberDecimalSymbols">
          <ng-container *ngFor="let separatorSymbol of numberSeparatorSymbols">
            <gp-dropdown-option *ngIf="decimalSymbol !== separatorSymbol"
                                [ngValue]="decimalSymbol + separatorSymbol">
              1{{ separatorSymbol }}234{{ separatorSymbol }}567{{ decimalSymbol }}89
            </gp-dropdown-option>
          </ng-container>
        </ng-container>
      </gp-dropdown-select>
    </div>

    <div class="profile-field" test-id="profile-drawer-date-format">
      <label>{{ 'ME.your_dateFormat' | translate }}</label>
      <gp-dropdown-select formControlName="dateFormat"
                          buttonClasses="w-100"
                          menuClasses="dropdown-menu-min">
        <gp-dropdown-option *ngFor="let dateFormat of dateFormats" [ngValue]="dateFormat">
          {{ dateFormat }}
        </gp-dropdown-option>
      </gp-dropdown-select>
    </div>

    <div class="profile-field">
      <label>{{ 'ME.user_email' | translate }}</label>
      <input type="email" class="form-control" formControlName="email">
    </div>

    <div class="profile-field-inline" test-id="profile-drawer-send-email">
      <label>{{ 'my_profile_email_enabling_text' | translate }}</label>
      <label class="ui-switch v-m">
        <input type="checkbox" formControlName="sendEmail">
        <em></em>
      </label>
    </div>

    <div class="profile-field-inline">
      <label>{{ 'ME.autoSave' | translate }}</label>
      <label class="ui-switch v-m">
        <input type="checkbox" formControlName="autoSave">
        <em></em>
      </label>
    </div>

    <button *ngIf="canChangePassword"
            type="button"
            class="btn btn-outline-default change-password-btn"
            test-id="profile-drawer-change-password"
            (click)="onChangePassword()">
      {{ 'NAVBAR.change_my_password' | translate }}
    </button>
  </ng-container>

  <!-- Footer: Logout + Save changes -->
  <div drawer-footer class="profile-footer">
    <button type="button" class="btn logout-btn" (click)="onLogout()">
      {{ 'NAVBAR.sign_out' | translate }}
    </button>
    <button type="button" class="btn btn-dark p-x-md save-btn" (click)="save()" [disabled]="saving || !hasChanges()">
      {{ 'ME.save_changes' | translate }}
    </button>
  </div>
</gp-drawer>



